module.exports = __webpack_public_path__ + "img/sky.cee1e467.svg";